<!-- 理光实物审批 -->
<template>
	<div class="process-page">
		<!-- 机器零件信息 -->
		<div class="create-section">
			<div class="mb20" v-if="faultyExpress != null">
				<el-button type="primary" @click="handleCheckExpress">查看实物寄件信息</el-button>
			</div>
			<h3>
				{{ partTitleObj[repairType] }}信息
				<el-button type="primary" @click="handleAddPart">新增{{ partTitleObj[repairType] }}</el-button>
			</h3>
			<!-- 动态生成的零件信息部分 -->
			<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
				<div class="flex-1">
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}名称</p>
							<p class="content">{{ part.partsName }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}编号</p>
							<p class="content">{{ part.partsNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">申请数量</p>
							<p class="content">{{ part.partsAmount }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
					</div>
					<div class="part-info-item" v-if="part.partsBatchNumber != null">
						<div class="info-box">
							<p class="title">批号</p>
							<p class="content">{{ part.partsBatchNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
					</div>
					<div class="t-r mt10">
						<el-button type="primary" size="small" @click="handleAddPartBatchNumber(part.id)">添加批号</el-button>
						<el-button type="primary" size="small" @click="handleUpdatePart(part)">编辑</el-button>
					</div>
				</div>
				<div class="flex-1 part-info-box-right">
					<div class="right-item">零件索赔进度： 实物审批中</div>
					<div class="right-item" v-if="part.partsResult == '1' && part.partsClaimExpress != null">
						<el-button type="info" @click="handleAddressInfo(part.id)">查看索赔退件信息</el-button>
					</div>
					<div class="right-item">
						此零件索赔结果：
						<el-radio v-model="part.partsResult" label="1">拒绝</el-radio>
						<el-radio v-model="part.partsResult" label="2">同意并安排发货</el-radio>
					</div>
					<div class="right-item" v-if="part.partsResult == '1'">
						<el-button type="primary" @click="handleAddressInfo(part.id)">填写退件信息</el-button>
					</div>
					<div class="right-item" v-if="part.partsResult == '2'">
						选择索赔发货方：
						<el-radio v-model="part.shipperType" label="1">服务部自行发货</el-radio>
						<el-radio v-model="part.shipperType" label="2">订单科发货</el-radio>
					</div>
					<div class="right-item flex">
						<span>附件说明</span>
						<div class="flex-1">
							<el-upload
								:action="action"
								:headers="headers"
								:multiple="true"
								:show-file-list="false"
								:before-upload="handleBeforeUpload"
								:on-error="handleError"
								:on-success="(res, file, list) => handleSuccess(index, res, file, list)">
								<el-button icon="el-icon-paperclip">上传文件</el-button>
							</el-upload>
							<FileList :file-list="part.fileList" :list-name="String(index)" closable @onRemove="handleAttachFileRemove" class="mt4"></FileList>
						</div>
					</div>
				</div>
			</div>
			<div class="process-item">
				<p>
					申请方的CPI地址
					<!--<span class="tips">(之后相关邮寄都将发往该地址)</span>-->
				</p>
				<el-select
					v-model="partsClaimWarranty.applyAdvanceCode"
					filterable
					remote
					placeholder="请输入发起方CPI/机构名称/收件人信息"
					:remote-method="getClaimRepairAdvance">
					<el-option
						v-for="item in options"
						:key="item.advanceCode"
						:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
						:value="item.advanceCode"></el-option>
				</el-select>
			</div>
			<div class="process-item">
				<p>
					保修截至日期
					<span class="tips">(在保修张数以内)</span>
				</p>
				<el-radio v-model="partsClaimWarranty.warrantyExpireType" label="1" :disabled="warrantyExpireFlag">按购货发票日期保修</el-radio>
				<el-radio v-model="partsClaimWarranty.warrantyExpireType" label="2" :disabled="warrantyExpireFlag">按理光出库日保修</el-radio>
				<el-radio v-model="partsClaimWarranty.warrantyExpireType" label="3" :disabled="warrantyExpireFlag">其他</el-radio>
				<br />
				<el-date-picker
					v-model="partsClaimWarranty.warrantyExpireDate"
					format="yyyy-MM-dd"
					value-format="yyyy-MM-dd"
					type="date"
					placeholder="请选择保修截至日期"
					:disabled="warrantyExpireFlag"></el-date-picker>
			</div>
			<div class="process-item" v-if="faultyExpress != null">
				<p>请根据物流情况填写索赔件实际到货时间</p>
				<el-date-picker
					v-model="partsClaimWarranty.receivedTime"
					type="datetime"
					format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
					:picker-options="pickerOptions"
					placeholder="请选择日期时间"></el-date-picker>
			</div>
			<div class="process-item">
				<p>审批批注</p>
				<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="auditRemarks"></el-input>
			</div>
			<div class="report-book-box">
				<h2>现场技术问题报告书(请先完成上方零件的审批)</h2>
				<el-button type="info" icon="el-icon-download" @click="handleDownloadPdf">下载现场技术问题报告书</el-button>
				<p class="title1">现场技术问题报告书</p>
				<p class="title2">请打印签字后上传</p>
				<el-upload
					:action="action"
					:headers="headers"
					:multiple="true"
					:show-file-list="false"
					:before-upload="handleBeforeUpload"
					:on-error="handleError"
					:on-success="(res, file, list) => handleSuccess('report', res, file, list)">
					<el-button icon="el-icon-paperclip">上传文件</el-button>
				</el-upload>
				<FileList :file-list="issueReportFileIdList" :list-name="'report'" closable @onRemove="handleAttachFileRemove" class="mt4"></FileList>
			</div>
			<div class="create-footer">
				<el-button type="info" @click="handleSubmit('0')">暂存</el-button>
				<el-button type="primary" @click="handleSubmit('1')">提交</el-button>
			</div>
		</div>

		<AddPart ref="addPart" @refresh="getClaimWarrantyInfo"></AddPart>
		<UpdatePart ref="updatePart" @refresh="getClaimWarrantyInfo"></UpdatePart>
		<addPartBatchNumber ref="addPartBatchNumber" @refresh="getClaimWarrantyInfo"></addPartBatchNumber>
		<AddressInfo ref="addressInfo" @refresh="setFaultyExpress"></AddressInfo>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<!-- 现场技术问题报告书 -->
		<appendix1 ref="appendix1"></appendix1>
		<!-- 流程信息 -->
		<CommonCollapse1 />
	</div>
</template>
<script>
import { processInfo } from "@/api/claim";
const defaultSettings = require("@/settings.js");
const hostName = defaultSettings.hostName;
import FileList from "../components/FileList.vue";
import AddPart from "../components/addPart.vue";
import addPartBatchNumber from "../components/addPartBatchNumber.vue";
import AddressInfo from "../components/addressInfo.vue";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import { debounce } from "@/utils/debounce";
import appendix1 from "@/components/PdfTemplate/AppendixReport/appendix1.vue";
import CommonCollapse1 from "../components/CommonCollapse1.vue";
import UpdatePart from "../components/updatePart.vue";
export default {
	components: {
		FileList,
		AddPart: AddPart,
		addPartBatchNumber,
		AddressInfo,
		ShowAddressInfo,
		appendix1,
		CommonCollapse1,
		UpdatePart,
	},
	data() {
		return {
			mainId: "",
			repairType: "",
			partsDetailList: [],
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			// 申请方的CPI地址
			options: [],
			// 审批批注
			auditRemarks: "",
			// 查看实物寄件信息
			faultyExpress: null,
			partsClaimWarranty: {
				id: "",
				applyAdvanceCode: "",
				warrantyExpireType: "",
				warrantyExpireDate: "",
				receivedTime: "",
				issueReportFileIdList: [],
			},
			issueReportFileIdList: [],
			innerAdvanceCode: "",
			applyAdvanceCode: "",
			form: null,
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期（只能选今天及之前）
					return time.getTime() > Date.now();
				},
			},
			// 故障件发货时间
			createTime: "",
			// 是否是保修截至日期
			warrantyExpireFlag: false,
		};
	},
	computed: {
		action() {
			return hostName + "bsi/sysAttachFile/addFileOss";
		},
		headers() {
			const token = sessionStorage.getItem("token") || "";
			return {
				token: token,
			};
		},
		// 是否是超级管理员
		isSuperAdmin() {
			const userInfoStr = window.sessionStorage.getItem("userInfo");
			if (!userInfoStr) return false;
			const userInfo = JSON.parse(userInfoStr);
			if (!userInfo) return false;
			if (userInfo.superAdminFlag === "1") return true;
			return false;
		},
	},
	mounted() {
		this.getClaimWarrantyInfo();
	},
	methods: {
		// 获取单个索赔信息
		getClaimWarrantyInfo() {
			// 获取单个索赔信息
			const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
			let self = this;
			processInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						sessionStorage.setItem("claimId", r.data.id);
						sessionStorage.setItem("repairType", r.data.repairType);
						sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
						self.mainId = r.data.id;
						self.faultyExpress = r.data.partsClaimWarranty.faultyExpress;
						self.innerAdvanceCode = r.data.partsClaimWarranty.innerAdvanceCode;
						self.applyAdvanceCode = r.data.partsClaimWarranty.applyAdvanceCode;
						if (r.data.partsClaimWarranty.applyAdvanceCode) {
							self.getAdvance({
								advanceType: "0",
								advanceCode: r.data.partsClaimWarranty.applyAdvanceCode,
							});
						} else {
							self.getClaimRepairAdvance();
						}

						self.repairType = r.data.repairType;
						// partsClaimWarranty
						self.partsClaimWarranty.id = r.data.partsClaimWarranty.id;
						r.data.partsClaimWarranty.applyAdvanceCode == null
							? ""
							: (self.partsClaimWarranty.applyAdvanceCode = r.data.partsClaimWarranty.applyAdvanceCode);
						r.data.partsClaimWarranty.warrantyExpireType == null
							? ""
							: (self.partsClaimWarranty.warrantyExpireType = String(r.data.partsClaimWarranty.warrantyExpireType));
						r.data.partsClaimWarranty.warrantyExpireDate == null
							? ""
							: (self.partsClaimWarranty.warrantyExpireDate = r.data.partsClaimWarranty.warrantyExpireDate);
						r.data.partsClaimWarranty.receivedTime == null ? "" : (self.partsClaimWarranty.receivedTime = r.data.partsClaimWarranty.receivedTime);
						r.data.partsClaimWarranty.issueReportFileList.length > 0
							? (self.issueReportFileIdList = [...r.data.partsClaimWarranty.issueReportFileList])
							: "";
						// partsDetailList
						// 方法1：使用 Vue.set 或 this.$set（Vue 2）
						for (const element of r.data.partsDetailList) {
							element.partsResult == null ? (element.partsResult = "") : (element.partsResult = String(element.partsResult));
							element.shipperType == null ? (element.shipperType = "") : (element.shipperType = String(element.shipperType));
							if (element.fileList.length > 0) {
								self.$set(element, "fileList", [...element.fileList]); // 确保响应式
							} else {
								self.$set(element, "fileList", []); // 确保响应式
							}
						}
						self.partsDetailList = [...r.data.partsDetailList];
						self.form = Object.assign({}, self.form, r.data);
						self.createTime = r.data.currentAudit.createTime;
						self.warrantyExpireFlag = r.data.partsClaimWarranty.warrantyExpireFlag == "1" ? true : false;
						if (r.data.remarks) {
							self.auditRemarks = r.data.remarks;
						}
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 获取申请方的CPI地址邮寄地址
		getClaimRepairAdvance(query) {
			let self = this;
			const params = { advanceType: "0" };
			if (query) {
				params.searchKey = query;
			}
			self.$request.post("getClaimRepairAdvance", false, params, function (r) {
				if (r.code == "0") {
					self.options = r.data.slice(0, 10);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		getAdvance(params) {
			let self = this;
			self.$request.post("getClaimRepairAdvance", false, params, function (r) {
				if (r.code == "0") {
					if (params.advanceType == "0") {
						self.options = r.data.slice(0, 10);
					}
					if (params.advanceType == "1") {
						self.innerAdvanceOptions = r.data.slice(0, 10);
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 提交
		handleSubmit: debounce(function (type) {
			if (type == "1") {
				this.updateWarranty(type);
			} else {
				this.updateWarranty(type);
			}
		}, 1000),
		// 提交接口
		updateWarranty(type) {
			let self = this;
			const params = {
				id: self.mainId,
				isSubmitParts: type,
				auditRemarks: self.auditRemarks,
			};
			let partsDetailList = [];
			// 拒绝索赔需要填写退件信息
			let flag1 = false;
			// 都拒绝只需要填写审批批注就行
			let flag2 = false;
			// 请选择零件索赔结果
			let flag3 = false;
			// 请选择索赔发货方
			let flag4 = false;
			for (const element of self.partsDetailList) {
				let obj = {
					id: element.id,
					partsResult: element.partsResult,
				};
				if (element.partsResult == "2") {
					obj.shipperType = element.shipperType;
				}
				let fileIdList = [];
				if (element.fileList.length > 0) {
					for (const file of element.fileList) {
						fileIdList.push(file.id);
					}
				}
				obj.fileIdList = fileIdList;
				partsDetailList.push(obj);
				// 请选择零件索赔结果
				if (element.partsResult == "") {
					flag3 = true;
				}
				// 请选择索赔发货方
				if (element.partsResult == "2" && element.shipperType == "") {
					flag4 = true;
				}
				// 拒绝需要退件地址
				if (element.partsResult == "1" && element.partsClaimExpress == null) {
					flag1 = true;
				}
				// 同意发货
				if (element.partsResult == "2") {
					flag2 = true;
				}
			}
			if (type == "1" && flag1) {
				self.$message.error(`请填写退件信息`);
				return;
			}
			if (type == "1" && flag3) {
				self.$message.error(`请选择零件索赔结果`);
				return;
			}
			if (type == "1" && flag4) {
				self.$message.error(`请选择索赔发货方`);
				return;
			}
			if (type == "1" && self.partsClaimWarranty.applyAdvanceCode == "") {
				self.$message.error(`请输入申请方的CPI地址`);
				return;
			}
			if (type == "1" && self.partsClaimWarranty.warrantyExpireType == "") {
				self.$message.error(`请选择保修截至日期类型`);
				return;
			}
			if (type == "1" && self.partsClaimWarranty.warrantyExpireDate == "") {
				self.$message.error(`请选择保修截至日期`);
				return;
			}
			if (type == "1" && self.partsClaimWarranty.receivedTime == "" && self.faultyExpress != null) {
				self.$message.error(`请选择索赔件实际到货时间`);
				return;
			}
			if (type == "1" && self.partsClaimWarranty.receivedTime < self.createTime && self.faultyExpress != null) {
				self.$message.error(`索赔件实际到货时间请大于故障件发货的时间${self.createTime}`);
				return;
			}
			if (type == "1" && self.auditRemarks == "") {
				self.$message.error(`请输入审批批注`);
				return;
			}
			if (type == "1" && self.issueReportFileIdList.length == 0 && flag2) {
				self.$message.error(`请上传现场技术问题报告书`);
				return;
			}

			let issueReportFileIdList = [];
			if (self.issueReportFileIdList.length > 0) {
				for (const file of self.issueReportFileIdList) {
					issueReportFileIdList.push(file.id);
				}
			}
			self.partsClaimWarranty.issueReportFileIdList = issueReportFileIdList;
			params.partsClaimWarranty = self.partsClaimWarranty;
			params.partsDetailList = partsDetailList;
			self.$request.post("updateWarranty", true, params, function (r) {
				if (r.code == "0") {
					self.$message({
						message: "操作成功",
						type: "success",
					});
					if (type == "1") {
						self.$router.push({
							name: "claimReviewList",
						});
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 上传前校验
		handleBeforeUpload(file) {
			if (this.isSuperAdmin) {
				// 超管单个文件大小限制1G
				const limitSize = file.size / 1024 / 1024 / 1024 <= 1;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过1G");
					return false;
				}
			} else {
				// 非超管单个文件大小限制255M
				// 2022-07-31 应客户要求改为200M
				const limitSize = file.size / 1024 / 1024 <= 200;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过200M");
					return false;
				}
			}
		},
		// 上传失败回调
		handleError(err, file, fileList) {
			console.log(`handleError`);
			console.log(err);
		},
		// 上传成功回调
		handleSuccess(index, response, file, fileList) {
			console.log(`handleSuccess`);
			if (index == "report") {
				this.issueReportFileIdList.push(file.response.data);
			} else {
				this.partsDetailList[index].fileList.push(file.response.data);
			}
		},
		// 删除上传文件
		handleAttachFileRemove(file, listName) {
			console.log(file);
			const index = listName;
			if (index == "report") {
				let array = [];
				for (const element of this.issueReportFileIdList) {
					if (element.id != file.id) {
						array.push(element);
					}
				}
				this.issueReportFileIdList = [...array];
			} else {
				let array = [];
				for (const element of this.partsDetailList[index].fileList) {
					if (element.id != file.id) {
						array.push(element);
					}
				}
				this.$set(this.partsDetailList[index], "fileList", [...array]);
			}
		},
		// 新增零件
		handleAddPart() {
			this.$refs.addPart.init(this.mainId);
		},
		// 添加批号
		handleAddPartBatchNumber(id) {
			this.$refs.addPartBatchNumber.init(id);
		},
		// 编辑零件
		handleUpdatePart(row) {
			this.$refs.updatePart.init(row);
		},
		// 填写退件信息
		handleAddressInfo(id) {
			this.$refs.addressInfo.init({
				id: id,
				linkTable: "parts_claim_detail",
				expressType: "2",
				applyAdvanceCode: this.applyAdvanceCode,
				innerAdvanceCode: this.innerAdvanceCode,
			});
		},
		// 点击查看实物寄件信息
		handleCheckExpress() {
			this.$refs.showAddressInfo.init(this.faultyExpress);
		},
		// 设置faultyExpress
		setFaultyExpress(id, partsClaimExpress) {
			for (const element of this.partsDetailList) {
				if (element.id == id) {
					element.partsClaimExpress = partsClaimExpress;
				}
			}
		},
		// 下载pdf
		handleDownloadPdf() {
			// 默认模板
			const newForm = {
				...this.$data,
			};
			if (!newForm) {
				console.error("默认模板 data is undefined");
				return;
			}
			newForm.partsDetailLists = this.partsDetailList;
			newForm.auditRemarks = this.auditRemarks;
			this.$refs.appendix1.init(newForm);
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}
.create-section {
	border-top: 1px solid #ddd;
	padding-top: 20px;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
	min-width: 0;
	word-wrap: break-word;
}
h3 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
	}
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
	.el-select {
		width: 100%;
	}
}
.t-r {
	text-align: right;
}
.mt10 {
	margin-top: 10px;
}
.mb20 {
	margin-bottom: 20px;
}
.report-book-box {
	margin-top: 20px;
	h2 {
		margin-bottom: 10px;
	}
	.title1 {
		font-size: 14px;
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		margin-top: 5px;
		margin-bottom: 10px;
	}
}
.tips {
	font-size: 13px;
	color: #909399;
}
</style>
